import React from 'react';
import { ChevronDown } from 'lucide-react';

interface PhoneInputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  disabled?: boolean;
}

export const PhoneInput: React.FC<PhoneInputProps> = ({ disabled, className, ...props }) => {
  return (
    <div className={`flex gap-3 ${disabled ? 'opacity-70' : ''}`}>
      <div className="relative min-w-[100px]">
        <select
            disabled={disabled}
            className={`
            w-full h-full pl-4 pr-8 py-3.5 appearance-none rounded-xl border outline-none bg-white
            text-slate-700 font-medium text-sm transition-all cursor-pointer
            ${disabled ? 'bg-slate-50 border-slate-300 text-slate-400 cursor-not-allowed' : 'border-slate-300 focus:border-primary focus:ring-1 focus:ring-primary'}
            `}
        >
          <option>+86</option>
          <option>+1</option>
          <option>+44</option>
          <option>+65</option>
        </select>
        <ChevronDown size={16} className="absolute right-3 top-1/2 -translate-y-1/2 text-slate-400 pointer-events-none" />
      </div>
      <div className="flex-1">
        <input
            disabled={disabled}
            type="tel"
            className={`
            w-full px-4 py-3.5 rounded-xl border outline-none transition-all text-sm leading-relaxed font-medium
            ${disabled
                ? 'bg-slate-50 border-slate-300 text-slate-400 placeholder:text-slate-300 cursor-not-allowed'
                : 'border-slate-300 focus:border-primary focus:ring-1 focus:ring-primary text-slate-900 placeholder:text-slate-400'}
            ${className}
            `}
            {...props}
        />
      </div>
    </div>
  );
};
